module.exports = __webpack_public_path__ + "img/img4.1bebe265.png";